import {Injectable} from "@angular/core";
import {
  CONFIG_FILE_NAME, CONFIG_FOLDER_FILE, CONFIG_VALUE_URL, CONFIG_VALUE_STORE_ID, CONFIG_KEY_URL, CONFIG_KEY_STORE_ID,
  CONFIG_KEY_IS_REMEMBER_ME_ENABLED, CONFIG_KEY_IS_SETUP_WIZARD_ENABLED, CONFIG_VALUE_IS_REMEMBER_ME_ENABLED,
  CONFIG_VALUE_IS_SETUP_WIZARD_ENABLED,
} from "../app/app.constants";
import {File} from "@ionic-native/file";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";

@Injectable()
export class ConfigurationFileService{

  private tag = '[FILE_SERVICE]';

  constructor(public file: File) {

  }


  createConfigurationFile(): Observable<any> {

   /* let jsonFileText= JSON.stringify(CONFIG_FILE_TEXT);
    console.log(this.tag, "*********************",jsonFileText);*/
    return Observable.create((observer: Observer<any>) => {
      this.file.createDir(this.file.externalRootDirectory, CONFIG_FOLDER_FILE, true)
        .then(() => {
          console.log(this.tag, "Creating tracker Retail Configuration directory");
          this.file.writeFile(this.file.externalRootDirectory + CONFIG_FOLDER_FILE, CONFIG_FILE_NAME,
            '{' + '\n'
            + '\t\"' + CONFIG_KEY_URL + '\"' + ':' + '\"' + CONFIG_VALUE_URL + '\"' + ',' + '\n'
            + '\t\"' + CONFIG_KEY_STORE_ID + '\"' + ':' + CONFIG_VALUE_STORE_ID + ',' + '\n'
            + '\t\"' + CONFIG_KEY_IS_REMEMBER_ME_ENABLED + '\"' + ':' + CONFIG_VALUE_IS_REMEMBER_ME_ENABLED + ',' + '\n'
            + '\t\"' + CONFIG_KEY_IS_SETUP_WIZARD_ENABLED + '\"' + ':' + CONFIG_VALUE_IS_SETUP_WIZARD_ENABLED + '\n'
            + '}'
            ,
            {replace: true})
            .then(() => {
              console.log(this.tag, "Creating tracker Retail Configuration file");
              observer.next(true);

            })
            .catch((err) => {
              console.error("Could not create configutation File", err);
              observer.next(err);

            });

        })
        .catch((err) => {
          console.error("Could not create configutation Directory", err);
          observer.next(err);
        });
      ;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/configuration.file.service.ts